import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard, AtLeastAdminGuard} from '@app/_guards';
import {NonInfluencerGuard} from '@app/_guards/non-influencer.guard';
import {PackageListComponent} from '@app/modules/packages/package-list/package-list.component';
import {PackageAddComponent} from '@app/modules/packages/package-add/package-add.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'system-admin/packages',
        component: PackageListComponent,
        canActivate: [AuthGuard, NonInfluencerGuard, AtLeastAdminGuard],
        data: {permission: 'view-packages'}
      },
      {
        path: 'system-admin/packages/add',
        component: PackageAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard, AtLeastAdminGuard],
        data: {permission: 'view-packages'}
      },
      {
        path: 'system-admin/packages/edit/:id',
        component: PackageAddComponent,
        canActivate: [AuthGuard, NonInfluencerGuard, AtLeastAdminGuard],
        data: {permission: 'view-packages'}
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PackagesRoutingModule { }
